import { Formik } from "formik";

import {
  Dialog,
  DialogTitle,
  Grid,
  DialogContent,
  DialogActions,
  Button,
  MenuItem,
} from "@mui/material";
import { TextField } from "../../../../components";
import { useComponent } from "../../../../hooks";

export default function OptionPopUp({
  addOptionPopUp,
  setAddOptionPopUp,
  formikProps,
}) {
  const { alert } = useComponent();
  return (
    <Dialog open={addOptionPopUp.state} onClose={handleClose} fullWidth>
      <DialogTitle
        style={{
          borderBottom: "1px solid #cbcbcb",
          fontSize: "30px!important",
        }}
      >
        Option Fields
      </DialogTitle>

      <Formik
        enableReinitialize
        initialValues={addOptionPopUp.data}
        validateOnMount
        onSubmit={(formData, { setSubmitting }) => {
          if (addOptionPopUp.mode === "add") {
            var options = [...formikProps.values.options];
            for (let option of options) {
              if (option.option_value === formData.option_value) {
                alert.error("Please provide unique option ID.");
                setSubmitting(true);
                return;
              }
            }
            formData = {
              ...formData,
              is_active: true,
            };
            formikProps.setValues((prevVal) => ({
              ...prevVal,
              options: [...prevVal.options, formData],
            }));
            setSubmitting(false);
          } else {
            formikProps.setValues((prevValue) => {
              let newOptions = [];

              for (let options of prevValue.options) {
                if (options.option_value === formData.option_value) {
                  newOptions.push(formData);
                } else {
                  newOptions.push(options);
                }
              }

              return {
                ...prevValue,
                options: newOptions,
              };
            });
            setSubmitting(false);
          }
          handleClose(false);
        }}
      >
        {(dialogFormikProps) => (
          <form noValidate onSubmit={dialogFormikProps.handleSubmit}>
            <DialogContent>
              <Grid container spacing={4}>
                <Grid size={12}>
                  <TextField
                    name="option_value"
                    label="Option Value"
                    disabled={Boolean(addOptionPopUp.data?.option_value)}
                    formikProps={dialogFormikProps}
                  />
                </Grid>

                <Grid size={12}>
                  <TextField
                    name="option_text"
                    label="Option Label"
                    formikProps={dialogFormikProps}
                  />
                </Grid>

                <Grid size={12}>
                  <TextField
                    select
                    name="is_active"
                    label="Status"
                    formikProps={dialogFormikProps}
                  >
                    <MenuItem value={true}>Active</MenuItem>
                    <MenuItem value={false}>Inactive</MenuItem>
                  </TextField>
                </Grid>
              </Grid>
            </DialogContent>

            <DialogActions style={{ padding: "12px 24px 24px" }}>
              <Grid container spacing={2}>
                <Grid size={6}>
                  <Button
                    variant="outlined"
                    color="primary"
                    onClick={handleClose}
                    value="save"
                  >
                    Cancel
                  </Button>
                </Grid>

                <Grid size={6} style={{ textAlign: "end" }}>
                  <Button
                    onClick={dialogFormikProps.handleSubmit}
                    variant="contained"
                    color="primary"
                    disabled={
                      dialogFormikProps.dirty
                        ? dialogFormikProps.isSubmitting ||
                          !dialogFormikProps.isValid
                        : !dialogFormikProps.dirty
                    }
                  >
                    Save
                  </Button>
                </Grid>
              </Grid>
            </DialogActions>
          </form>
        )}
      </Formik>
    </Dialog>
  );

  function handleClose() {
    setAddOptionPopUp({
      state: false,
      data: {},
    });
  }
}
